import { API } from '@constants'

export const API_SEARCH = `${API}/search`
export const API_SEARCH_RESORT_LIST = `${API_SEARCH}/resortList`
export const API_SEARCH_LOCATION_LIST = `${API_SEARCH}/locationList`
export const API_SEARCH_CAL_AVAIL = `${API_SEARCH}/calAvail`
export const API_SEARCH_RESORT_AVAIL = `${API_SEARCH}/resortAvail`
export const API_SEARCH_CONSTRAINTS = `${API_SEARCH}/searchConstraints`
export const API_REGION_LIST = `${API_SEARCH}/regionList`
export const API_SEARCH_EXPLORE_LOCATIONS = `${API_SEARCH}/exploreLocations`
export const API_SEARCH_FILTERS = `${API_SEARCH}/filters`
export const API_SEARCH_STAY_RULES = `${API_SEARCH}/stayRules`
export const API_SEARCH_ALL_RESORT_AVAIL = `${API_SEARCH}/allResortAvail`

export const LOCATION_PATH = 'locationPath'
export const ALL_SUITES = 'All Suites'

export const FILTER_SECTION_SPECIAL = 'special'
export const ACCESSIBILITY_FILTER_NAME = 'Accessibility'
export const SHOW_AVAILABLE_RESORTS_ONLY = 'Show Available Resorts Only'
